import { render, staticRenderFns } from "./DxUploadFile.vue?vue&type=template&id=138140da&"
import script from "./DxUploadFile.vue?vue&type=script&lang=js&"
export * from "./DxUploadFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports